var React = require('react');

function HospitalSymbol (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-88h-96v88a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8V136a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v88h96v-88a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M368 376a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-88h-96v88a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8V136a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v88h96v-88a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8z","className":"fa-primary","key":2})]);
}

HospitalSymbol.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HospitalSymbol;

HospitalSymbol.default = HospitalSymbol;
